import {
  AcceptInvitationData,
  AcceptInvitationVars
} from 'membership/gql-types';
import React, { ChangeEvent, useState } from 'react';

import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Unstable_Grid2';
import MenuItem from '@mui/material/MenuItem';
import { PublicGraphQL } from '../gql';
import RegistrationSuccess from './RegistrationSuccess';
import TextField from '@mui/material/TextField';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { UserUsername } from '../models/User';
import styles from '../styles/UserListForEmailVerification.module.css';
import { useMutation } from '@apollo/client';

interface UserListForEmailVerificationProps {
  token: string;
  email: string;
  users: UserUsername[];
}

const UserListForEmailVerification = (
  props: UserListForEmailVerificationProps
) => {
  const [userkey, setUserkey] = useState<number>(props.users[0]?.userkey);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const userkey = +e.target.value;
    setUserkey(userkey);
  };

  const [acceptInvitation, { loading, error, data }] = useMutation<
    AcceptInvitationData,
    AcceptInvitationVars
  >(PublicGraphQL.Mutation.ACCEPT_INVITATION);

  const handleClick = async () => {
    await acceptInvitation({
      variables: { token: props.token, userkey }
    });
  };

  return data?.acceptInvitation ? (
    <RegistrationSuccess
      email={props.email}
      verificationEmailSent={false}
      successMessage="Your account has been updated."
    />
  ) : (
    <>
      <Card>
        <CardHeader
          title="Select an Account"
          className={styles.title}
        ></CardHeader>
        <CardContent>
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid>
              <Typography variant="body1" align="center">
                {`Your email (${props.email}) is associated with several accounts. Please select the one you want to keep.`}
              </Typography>
            </Grid>
            <Grid className={styles.grid}>
              <form className={styles.form} noValidate autoComplete="off">
                <TextField
                  variant="standard"
                  select
                  fullWidth
                  label="Select username"
                  value={userkey}
                  disabled={loading}
                  onChange={handleChange}
                >
                  {props.users.map((user) => (
                    <MenuItem key={user.userkey} value={user.userkey}>
                      {user.username}
                    </MenuItem>
                  ))}
                </TextField>
              </form>
            </Grid>
            {error && (
              <Grid>
                <Typography color="error">
                  {`${error.message || error}`}
                </Typography>
              </Grid>
            )}
          </Grid>
        </CardContent>
        <CardActions>
          <Grid container direction="column" alignItems="center">
            <Grid>
              <Button
                variant="contained"
                color="primary"
                disabled={!userkey || loading}
                onClick={handleClick}
              >
                {loading ? 'Processing...' : 'Continue'}
              </Button>
            </Grid>
          </Grid>
        </CardActions>
      </Card>
    </>
  );
};

export default UserListForEmailVerification;
